import { render } from "./CoReg_Co_Detail.vue?vue&type=template&id=2067f7c4&scoped=true"
import script from "./CoReg_Co_Detail.vue?vue&type=script&lang=js"
export * from "./CoReg_Co_Detail.vue?vue&type=script&lang=js"

import "./CoReg_Co_Detail.vue?vue&type=style&index=0&id=2067f7c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2067f7c4"]])

export default __exports__